import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Row, Col, Button } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

const portletBreadcrumbs = [
  { name: 'Estados Financieros' },
  { name: 'Cierre Clase 6-7-9' },
  { name: 'Generacion de asientos' }
]

const GeneracionAsientosSection = ({ validarSaldoCeroClases6789 }) => {
  const __zariContext = React.useContext(ZariContext)

  const clickGenerarAsientosCierre = React.useCallback(() => {
    __zariContext.loader.open('Generando asientos de cierre.')

    AsientoContableService.generarAsientosCierre()
      .then(() => {
        __zariContext.snack('success', 'Asientos de cierre generados.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  React.useEffect(() => {
    setTimeout(() => {
      validarSaldoCeroClases6789()
    }, 500)
  }, [validarSaldoCeroClases6789])

  return (
    <Portlet>
      <Portlet.Header title='Estados Financieros' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Button onClick={clickGenerarAsientosCierre} tiny>
              Generar asientos de cierre
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(GeneracionAsientosSection)
